import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import type { Customer } from "@/types";

const CUSTOMER_COLUMNS =
  "id, first_name, last_name, document, phone, whatsapp, email, address, customer_type, notes, active, created_at, updated_at";

export interface CustomersData {
  customers: Customer[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export function useCustomersData(): CustomersData {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("customers")
        .select(CUSTOMER_COLUMNS)
        .order("created_at", { ascending: false });

      if (queryError) {
        setError("No se pudieron cargar los clientes.");
        setCustomers([]);
        return;
      }
      setCustomers((data ?? []) as Customer[]);
    } catch {
      setError("No se pudieron cargar los clientes.");
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { customers, loading, error, reload: load };
}